/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KnownMutation
 */
export interface KnownMutation {
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    protein?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    transcript?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    wtAA?: string;
    /**
     * 
     * @type {number}
     * @memberof KnownMutation
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    targetAA?: string;
    /**
     * 
     * @type {KnownMutationLabelEnum}
     * @memberof KnownMutation
     */
    label?: KnownMutationLabelEnum;
    /**
     * 
     * @type {number}
     * @memberof KnownMutation
     */
    category?: number;
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownMutation
     */
    description?: string;
}


/**
 * @export
 */
export const KnownMutationLabelEnum = {
    Oncogenic: 'ONCOGENIC',
    Benign: 'BENIGN'
} as const;
export type KnownMutationLabelEnum = typeof KnownMutationLabelEnum[keyof typeof KnownMutationLabelEnum];


/**
 * Check if a given object implements the KnownMutation interface.
 */
export function instanceOfKnownMutation(value: object): value is KnownMutation {
    return true;
}

export function KnownMutationFromJSON(json: any): KnownMutation {
    return KnownMutationFromJSONTyped(json, false);
}

export function KnownMutationFromJSONTyped(json: any, ignoreDiscriminator: boolean): KnownMutation {
    if (json == null) {
        return json;
    }
    return {
        
        'protein': json['protein'] == null ? undefined : json['protein'],
        'transcript': json['transcript'] == null ? undefined : json['transcript'],
        'wtAA': json['wtAA'] == null ? undefined : json['wtAA'],
        'position': json['position'] == null ? undefined : json['position'],
        'targetAA': json['targetAA'] == null ? undefined : json['targetAA'],
        'label': json['label'] == null ? undefined : json['label'],
        'category': json['category'] == null ? undefined : json['category'],
        'link': json['link'] == null ? undefined : json['link'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function KnownMutationToJSON(json: any): KnownMutation {
    return KnownMutationToJSONTyped(json, false);
}

export function KnownMutationToJSONTyped(value?: KnownMutation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'protein': value['protein'],
        'transcript': value['transcript'],
        'wtAA': value['wtAA'],
        'position': value['position'],
        'targetAA': value['targetAA'],
        'label': value['label'],
        'category': value['category'],
        'link': value['link'],
        'description': value['description'],
    };
}

